import { Duration } from '@bufbuild/protobuf/wkt'
import {
    hoursToSeconds,
    minutesToSeconds,
    secondsToHours,
    secondsToMinutes,
    set,
} from 'date-fns'
import { OmitDeepMessageFields } from '@/types/OmitDeepMessageFields'

/**
 * Transforms the passed `Duration` to a `Date`.
 * `baseDate` is used as the basis that the time will be set on.
 * @param baseDate
 * @param duration for the time portion.
 * @returns the duration set as the time of `baseDate`.
 */
export const durationToDate = (
    baseDate: Date,
    { nanos, seconds }: OmitDeepMessageFields<Duration>
) => {
    const hours = secondsToHours(Number(seconds))
    const minutes = secondsToMinutes(Number(seconds) - hoursToSeconds(hours))

    return set(baseDate, {
        milliseconds: nanos,
        seconds:
            Number(seconds) - hoursToSeconds(hours) - minutesToSeconds(minutes),
        minutes,
        hours,
    })
}
